import React, {useState} from 'react';
import {toast} from 'react-toastify';
import {Button, Modal} from 'react-bootstrap';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {uploadImage} from '@app/services/auth';

export default function FileUpload({callback}) {
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [activeLink, setActiveLink] = useState('');

  const handleClose = () => {
    setShow(false);
    setActiveLink('');
  };

  // const handleShow = () => setShow(true);

  const uploadDoc = async (image) => {

    setLoader(true);
    // setShowLoader(true)
    const resp = await uploadImage(image.target.files[0]);
    // setShowLoader(false)
    if (resp.data.ok) {
      // const assetResp = await updateDocAsset({ projectId: "637f6f51211c2334ac151bd1", link: resp.url });
      if(callback){
        callback(resp.data.fileName, resp.data.hash)

        }

      // callback(resp.fileName, resp.hash);
      // console.log("assetResp", assetResp)
      setActiveLink(window.location.origin + '/file/' + resp.data.hash);
      toast('File successfully uploaded');
      setShow(true);
      setLoader(false);
    } else {
    }
  };


  return (
    <>
      {loader ? (
        <label className="btn btn-default">Uploading..</label>
      ) : (
        <label className="btn btn-default">
          <i className="fas fa-upload mr-2"></i> File Upload{' '}
          <input onChange={uploadDoc} type="file" hidden />
        </label>
      )}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-group w-60">
            <input
              type="text"
              className="form-control"
              value={activeLink}
              disabled
            />
            <CopyToClipboard
              text={activeLink}
              onCopy={() => toast('Link Copied!')}
            >
              <button type="button" className="btn btn-secondary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-clipboard"
                  viewBox="0 0 16 16"
                >
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"></path>
                  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"></path>
                </svg>
              </button>
            </CopyToClipboard>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
